<template>
  <section aria-labelledby="notes-title">
          <div class="bg-white shadow sm:rounded-lg sm:overflow-hidden">
            <div class="border-b border-grey-200">
              <div class="px-4 py-5 sm:px-6">
                <p class="text-base text-grey-900 flex flex-row items-center font-bold">{{ $t('frontend_gd_dashboard_quick_links') }}</p>
              </div>
            </div>
            <div class="flex flex-row">
                <div
                    v-for="(link, index) in links"
                    :key="index"
                    class="
                    flex-1
                    flex flex-col
                    items-center
                    h-32
                    w-1/5
                    content-between
                    justify-between
                    cursor-pointer
                    border-r
                    border-grey-200
                    "
                    @click="callAction(link)"
                >
                    <div class="flex flex-wrap content-end h-16 text-grey-500">
                    <component :is="link.icon" class="h-8 w-8 text-grey-500" />
                    </div>
                    <div class="flex flex-wrap content-start h-16">
                        <p
                            class="text-sm text-color font-semibold text-center mt-2"
                            v-html="link.name"
                        ></p>
                    </div>
                </div>
            </div>
          </div>
        </section>
      </div>
</template>

<script>
export default {
  name: 'QuickLinks',
  props: {
    links: {},
  },
  methods: {
    callAction(link) {
      console.log(link);
      link.callback();
    },
  },
};
</script>
